<template>
  <div class="abstract-card">
    <div class="header">
      <div class="title d-flex justify-content-between">{{$t('components.abstract.tabs.abstractRules.limitSubmisson')}} <el-switch v-model="form.abstractRules.limitSubmissionPeriod"></el-switch></div>
      <span>{{$t('components.abstract.tabs.abstractRules.limitSubmissonMsg')}}</span>
    </div>
    <transition name="el-fade-in">
      <el-row :gutter="10" class="mt-2" v-if="form.abstractRules.limitSubmissionPeriod">
        <el-col :span="12">
          <div class="registerform-input-container mt-2">
            <div class="title">
              <div>
                <label>{{$t('components.abstract.tabs.abstractRules.startDate')}}</label>
                <el-tooltip content="Content" placement="bottom">
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </div>
            </div>
            <el-date-picker :format="datePickerDisplayFormat()" v-model="form.abstractRules.startDate" type="date" :placeholder="$t('components.abstract.tabs.abstractRules.pickDay')" class="w-100"> </el-date-picker>
            <span class="error">{{ $errorMessage('detailSettings.keywordsTitle', validationErrors) }}</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="registerform-input-container mt-2">
            <div class="title">
              <div>
                <label>{{$t('components.abstract.tabs.abstractRules.endDate')}}</label>
                <el-tooltip content="Content" placement="bottom">
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </div>
            </div>
            <el-date-picker :format="datePickerDisplayFormat()" class="w-100" v-model="form.abstractRules.endDate" type="date" :placeholder="$t('components.abstract.tabs.abstractRules.pickDay')"> </el-date-picker>
            <span class="error">{{ $errorMessage('detailSettings.keywordsTitle', validationErrors) }}</span>
          </div>
        </el-col>
      </el-row>
    </transition>
    <div class="header mt-3">
      <div class="title d-flex justify-content-between">{{$t('components.abstract.tabs.abstractRules.limitNumberSubmission')}} <el-switch v-model="form.abstractRules.limitNumberOfSubmissions"></el-switch></div>
      <span>{{$t('components.abstract.tabs.abstractRules.limitNumberSubmissionMsg')}}</span>
    </div>
    <transition name="el-fade-in">
      <el-row :gutter="10" v-if="form.abstractRules.limitNumberOfSubmissions" class="mt-3">
        <el-col :span="24">
          <el-button-group class="d-flex">
            <el-button size="mini" class="w-100" v-for="(button, buttonIndex) in getEnums.find((x) => x.title == 'SubmissionLimitType').enums" :key="buttonIndex" :type="form.abstractRules.limitType == button.key ? 'primary' : 'default'" round @click="changeType(button.key)">{{ button.displayName }}</el-button>
          </el-button-group>
        </el-col>
        <el-col :span="24" class="mt-3">
          <el-row :gutter="10">
            <el-col :span="24">
              <div class="limit-submission-head d-flex align-items-center">
                <div class="header">
                  <div class="title">{{$t('components.abstract.tabs.abstractRules.maxValueParticipant')}}</div>
                  <span>{{$t('components.abstract.tabs.abstractRules.maxValueParticipantMsg')}}</span>
                </div>
                <el-input-number v-model="form.abstractRules.limit" size="mini" :min="1"></el-input-number>
              </div>
            </el-col>
            <el-col :span="24" class="limited-items">
              <el-row :gutter="10" class="limited-item head">
                <el-col class="limited-item-title" :span="12">{{$t('components.abstract.tabs.abstractRules.presentationType')}}</el-col>
                <el-col class="limited-item-input" :span="12">{{$t('components.abstract.tabs.abstractRules.limitNumber')}}</el-col>
              </el-row>
              <el-row :gutter="10" class="limited-item mt-2" v-for="(item, itemIndex) in this.form.abstractRules.limits" :key="itemIndex">
                <el-col :span="12" class="limited-item-title">{{ item.title }}</el-col>
                <el-col :span="12" class="limited-item-input"><el-input-number size="mini" class="w-100" :min="1" v-model="item.limit"></el-input-number></el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </transition>
    <div class="bottom mt-3 d-flex justify-content-end">
      <el-button type="primary" size="mini" round :loading="loading" @click="saveAbstractRules">{{$t('components.abstract.tabs.abstractRules.save')}}</el-button>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['data'],
    data() {
      return {
        validationErrors: [],
        loading: false,
        timeout: null,
        form: {},
      };
    },
    computed: {
      getEnums() {
        return this.$store.getters.getEnums;
      },
      registerFormList() {
        return this.$store.getters.getRegisterFormList;
      },
    },
    methods: {
      changeType(type) {
        this.form.abstractRules.limitType = type;
        this.form.abstractRules.limits = [];
        if (type == 0) {
          this.form.presentationTypes.map((x) => {
            this.form.abstractRules.limits.push({ ...x, limit: 1 });
          });
        } else if (type == 1) {
          this.registerFormList.map((x) => {
            x.packets.map((y) => {
              this.form.abstractRules.limits.push({ ...y, limit: 1 });
            });
          });
        }
      },
      async saveAbstractRules() {
        if (this.timeout != null) clearTimeout(this.timeout);
        this.loading = true;
        this.timeout = setTimeout(async () => {
          var res = await this.$store.dispatch('abstractUpdateRules', this.form);
          this.validationErrors = res.data.validationErrors;
          this.loading = false;
        }, 500);
      },
      typeBase() {
        if (type == 0) {
          this.form.presentationTypes.map((x) => {
            this.form.abstractRules.limits.push({ ...x, limit: 1 });
          });
        } else if (type == 1) {
          this.registerFormList.map((x) => {
            x.packets.map((y) => {
              this.form.abstractRules.limits.push({ ...y, limit: 1 });
            });
          });
        }
      },
    },
    created() {
      if (this.data != undefined && this.data != null) {
        this.form = this.data;
      }
    },
    watch: {
      data: function() {
        if (this.data != undefined && this.data != null) {
          this.form = this.data;
          this.$nextTick(() => {
            if (this.form.abstractRules.limits.length == 0) {
              this.typeBase(this.form.abstractRules.limitType);
            }
          });
        }
      },
    },
  };
</script>

<style lang="less" scoped>
  .limited-items {
    margin-top: 1rem;
    border: 1px solid black;
    padding: 1rem !important;
    border-radius: 8px;
    .limited-item {
      display: flex;
      align-items: center;
      font-weight: bold;
      color: black;
    }
  }
  .limit-submission-head {
    color: black;
    gap: 1rem;
    & > .header {
      & > .title {
        font-weight: bold !important;
      }
      flex-grow: 1;
    }
    .el-input {
      flex-shrink: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/abstract/tabs/AbstractRules.vue